module.exports = __webpack_public_path__ + "img/立即订购BTN.0886fe9c.svg";